export default "__VITE_ASSET__D4oX3Ras__"